var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrouilleur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.01465C9.20914 9.01465 11 7.22379 11 5.01465C11 2.80551 9.20914 1.01465 7 1.01465C4.79086 1.01465 3 2.80551 3 5.01465C3 7.22379 4.79086 9.01465 7 9.01465Z",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 17.0146V15.0146C1 13.9538 1.42143 12.9364 2.17157 12.1862C2.92172 11.4361 3.93913 11.0146 5 11.0146H9C10.0609 11.0146 11.0783 11.4361 11.8284 12.1862C12.5786 12.9364 13 13.9538 13 15.0146V17.0146",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.14453C14.8604 1.36483 15.623 1.86523 16.1676 2.56684C16.7122 3.26845 17.0078 4.13136 17.0078 5.01953C17.0078 5.9077 16.7122 6.77061 16.1676 7.47222C15.623 8.17383 14.8604 8.67423 14 8.89453",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17.0146V15.0146C18.9949 14.1317 18.6979 13.2753 18.1553 12.579C17.6126 11.8826 16.8548 11.3853 16 11.1646",
    stroke: "#E7FFE7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouilleur);
export default __webpack_public_path__ + "static/media/grouilleur.df4142b7e4ea0e1c131fe4efcee3b80f.svg";
export { ForwardRef as ReactComponent };